import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import moment from 'moment'
import PropTypes from 'prop-types'
import DocumentTitle from 'react-document-title'

import { hfComplianceApi } from '@atheneum/api'
import { formatDateTime } from '@atheneum/api/dist/lib'

import Spinner from '@components/spinner'
import Error from '@components/Error/NoContent'

class HFCompliances extends Component {
  static propTypes = {
    staticData: PropTypes.object,
    expertStore: PropTypes.object
  }

  constructor (props) {
    super(props)
    extendObservable(this, {
      loading: true,
      hfCompliances: []
    })
    hfComplianceApi
      .getHfCompliances(props.expertStore.id)
      .then(hfCompliances => {
        this.hfCompliances.replace(hfCompliances)
        this.loading = false
      })
  }

  // TODO: add colors, perhaps similar to payment details' statuses
  renderStatus ({ createdAt, isConfirmed }) {
    const { staticData } = this.props
    const hasExpired = moment(createdAt).isBefore(
      moment().subtract(staticData.hfComplianceExpiryDays, 'days')
    )
    if (hasExpired) {
      return 'Expired'
    } else if (isConfirmed === false) {
      return 'Rejected'
    } else if (isConfirmed) {
      return 'Confirmed'
    } else {
      return 'Unconfirmed'
    }
  }

  renderUpdatedBy ({ employee }) {
    if (employee) {
      return employee.fullName
    } else {
      return '-'
    }
  }

  render () {
    if (this.loading) return <Spinner />
    if (!this.hfCompliances.length) return <Error />

    const { expertStore } = this.props

    return (
      <DocumentTitle
        title={`${expertStore.expert.fullName} - Hedge fund compliances | Atheneum Partners`}
      >
        <div className='details-wrapper animate-intro'>
          <div className='story'>
            <span className='label'>Hedge fund compliances</span>
            <table className='table-wrapper--nested'>
              <thead>
                <tr>
                  <th>Submission date</th>
                  <th>Status</th>
                  <th>Updated by</th>
                </tr>
              </thead>
              {this.hfCompliances.map(hfCompliance => (
                <tbody key={hfCompliance.id}>
                  <tr>
                    <td>
                      <Link to={`hf-compliance/${hfCompliance.id}`}>
                        {formatDateTime(hfCompliance.createdAt, false)}
                      </Link>
                    </td>
                    <td>{this.renderStatus(hfCompliance)}</td>
                    <td>{this.renderUpdatedBy(hfCompliance)}</td>
                  </tr>
                </tbody>
              ))}
            </table>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default inject('staticData', 'expertStore')(observer(HFCompliances))
